import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f91e950&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91e950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f91e950')) {
      api.createRecord('2f91e950', component.options)
    } else {
      api.reload('2f91e950', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f91e950&scoped=true", function () {
      api.rerender('2f91e950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/index.vue"
export default component.exports